// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3iw_v","inputWrap":"styles_inputWrap__CKjzK","input":"styles_input__rTsC1"};